// @ts-nocheck
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import translate from "@insite/client-framework/Translate";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { creditSummaryGridProps, creditSummaryStackProps } from "@store/Themes/common/props/credit";
import { useSession } from "@toolkit/Framework/Store/Context/ContextHooks";
import constants from "@store/constants";

export type CreditSummaryLayout = "grid" | "stack";

interface CreditSummaryProps {
    layout: CreditSummaryLayout;
    extendedStyles?: CreditSummaryStyles;
}

export interface CreditSummaryStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    innerWrapper?: InjectableCss;
    price?: TypographyProps;
    label?: TypographyProps;
    wrapperContainer?: GridContainerProps;
    titleWrapper?: InjectableCss;
    title?: TypographyProps;
    itemWrapper?: InjectableCss;
    itemLabel?: TypographyProps;
    itemValue?: TypographyProps;
}

export const creditSummaryStyles: CreditSummaryStyles = {
    gridContainer: creditSummaryGridProps.gridContainer,
    gridItem: creditSummaryGridProps.gridItem,
    innerWrapper: creditSummaryGridProps.innerWrapper,
    price: creditSummaryGridProps.price,
    label: creditSummaryGridProps.label,
    wrapperContainer: creditSummaryStackProps.wrapper,
    titleWrapper: creditSummaryStackProps.titleWrapper,
    title: creditSummaryStackProps.title,
    itemWrapper: creditSummaryStackProps.itemWrapper,
    itemLabel: creditSummaryStackProps.itemLabel,
    itemValue: creditSummaryStackProps.itemValue,
};

const CreditSummary = ({ layout, extendedStyles }: CreditSummaryProps) => {
    const { availableCreditDisplay, creditLimitDisplay, currentBalanceDisplay } = useSession().properties;
    const styles = useMergeProps(creditSummaryStyles, extendedStyles);

    const currentBalance = currentBalanceDisplay ?? constants.label.notAvailable;
    const creditLimit = creditLimitDisplay ?? constants.label.notAvailable;
    const availableCredit = availableCreditDisplay ?? constants.label.notAvailable;

    if (layout === "grid") {
        return (
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.gridItem}>
                    <StyledWrapper {...styles.innerWrapper}>
                        <Typography {...styles.price}>{currentBalance}</Typography>
                        <Typography {...styles.label}>{translate("Current Balance")}</Typography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <StyledWrapper {...styles.innerWrapper}>
                        <Typography {...styles.price}>{creditLimit}</Typography>
                        <Typography {...styles.label}>{translate("Credit Line")}</Typography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <StyledWrapper {...styles.innerWrapper}>
                        <Typography {...styles.price}>{availableCredit}</Typography>
                        <Typography {...styles.label}>{translate("Available Credit")}</Typography>
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        );
    }

    return (
        <StyledWrapper {...styles.wrapperContainer}>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{translate("Credit & Balances")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.itemLabel}>{translate("Current Balance")}</Typography>
                <Typography {...styles.itemValue}>{currentBalance}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.itemLabel}>{translate("Credit Line")}</Typography>
                <Typography {...styles.itemValue}>{creditLimit}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.itemLabel}>{translate("Available Credit")}</Typography>
                <Typography {...styles.itemValue}>{availableCredit}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CreditSummary;
